module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coming-soon"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    staticClass: "fal fa-cog"
  }), _vm._v(" "), _c('br'), _vm._v("\n        Vi arbejder pt. på denne funktion. Kig ind senere!\n    ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20fa3fe5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20fa3fe5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/comingSoon.vue
// module id = 795
// module chunks = 0